/**
 * @generated SignedSource<<5b53b9d18368de703071dd445a9192e8>>
 * @relayHash 67388e2ca589ea71c5bc78019291f753
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0aeae55c60694692712eb6fb1202579f75a724cf46da8cdbad6c77c475c9a5a2

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { PlaybookTemplatesQuery } from './PlaybookTemplatesQuery.graphql';

const node: PreloadableConcreteRequest<PlaybookTemplatesQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "0aeae55c60694692712eb6fb1202579f75a724cf46da8cdbad6c77c475c9a5a2",
    "metadata": {},
    "name": "PlaybookTemplatesQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
